import { CellComponentProps } from '@melements/front-components/dist/components/list/table/body/cell/Cell.types';
import React from 'react';

import { StatusFailIcon, StatusIconWrapper, StatusSuccessIcon } from './StatusIcon.styles';

export const StatusIcon = ({ value }: CellComponentProps<any>) => {
  return (
    <StatusIconWrapper>
      {!value && <StatusSuccessIcon className="status__icon status__icon--success" />}
      {value && <StatusFailIcon className="status__icon status__icon--fail" />}
    </StatusIconWrapper>
  );
};
